import { Field, Model } from 'serialize-ts';

@Model()
export class PricePerUnit {
  @Field()
  vatValue: number;

  @Field()
  unit: string;

  @Field()
  grossPrice: number;

  @Field()
  netPrice: number;

  @Field()
  currency: string;
}
